import { _ as _defineProperty } from '../../defineProperty-DmV7cVMj.js';
import AnalyticsService from '../analytics/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var sendAnalytics = function sendAnalytics(_ref) {
  var eventName = _ref.eventName,
    params = _ref.params;
  AnalyticsService.sendEvent(eventName, params);
};
var WebVitals = function WebVitals(url, appId) {
  var analytics = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : sendAnalytics;
  import('../../web-vitals-5AJrlBnC.js').then(function (_ref2) {
    var onCLS = _ref2.onCLS,
      onFID = _ref2.onFID,
      onFCP = _ref2.onFCP,
      onLCP = _ref2.onLCP,
      onTTFB = _ref2.onTTFB,
      onINP = _ref2.onINP;
    var initAnalitics = function initAnalitics(key, metrics) {
      analytics({
        eventName: 'page_vitals',
        params: _objectSpread(_objectSpread({
          page_url: url
        }, appId ? {
          package_id: appId
        } : {}), {}, _defineProperty(_defineProperty({}, key, metrics.value), "navigation_type", metrics.navigationType))
      });
    };
    onFCP(function (metrics) {
      initAnalitics('first_contentful_paint', metrics);
    });
    onTTFB(function (metrics) {
      initAnalitics('time_first_byte', metrics);
    });
    onLCP(function (metrics) {
      initAnalitics('largest_contentful_paint', metrics);
    });
    onCLS(function (metrics) {
      initAnalitics('cumulative_layout_shift', metrics);
    });
    onFID(function (metrics) {
      initAnalitics('first_input_delay', metrics);
    });
    onINP(function (metrics) {
      initAnalitics('interaction_to_next_paint', metrics);
    });
  });
};

export { WebVitals as default };
//# sourceMappingURL=index.js.map
